module.exports = __webpack_public_path__ + "static/media/RiskwellLogo.7aa29765.svg";